module.exports = __webpack_public_path__ + "img/6.5cc8fc29.png";